/*global  root, regexpEscape, htmlEncode */
/*eslint no-console: ["error", { allow: ["warn", "error", "debug", "log"] }] */

function HtmlTemplateManager(settings)
{

    if(typeof settings === "undefined") settings = {};

    /** {object} Holds the teplates in { {object} name: { {string} html, {object} data } } format. */
    var templates = {};

    var mainElement = settings.hasOwnProperty("mainElement") ? settings.mainElement : null;
    var customLoader = settings.hasOwnProperty("customLoader") ? settings.customLoader : false;
    var eventPrefix = settings.hasOwnProperty("eventPrefix") ? settings.eventPrefix : null;

    if(eventPrefix === null) console.error("Missing eventPrefix");
    if(customLoader === false && !mainElement) console.error("Main element is required!");

    this.loadTemplates = loadTemplates;
    this.getElement = getElement;
    this.getTemplate = getTemplate;
    this.replaceTemplateData = replaceTemplateData;

    /**
     * Load template from server (_view/templates/)
     * @param {array} templatesArray - The template name without the 'template-' prefix. {folder: folder, template: template}
     */
    function loadTemplates(templatesArray)
    {
        var html;

        if(!customLoader){
            $(mainElement).addClass("hide");
            $(".loader-screen").removeClass("hide");
        }

        $.ajax({
            type: "POST",
            async:true,
            data: {
                templates:templatesArray
            },
            url: root+"ajax/templateloader/loadTemplate",
            success: function (response) {
                var result =  JSON.parse(response);
                if(result){
                    var statuses = [];
                    $.each(result, function(name, templateData) {
                        var $template = $(templateData.html);
                        html = $template.html();
                        if(templateData.html != null) {
                            templates[name] = {
                                html: html,
                                data: $template.data(),
                                htmlEncode: templateData.htmlEncode
                            };
                            statuses[name] = true;
                        } else {
                            templates[name] = {
                                html: '',
                                data: null
                            };
                            console.log('WARNING: Missing template: '+name);
                            statuses[name] = false;
                        }
                    });

                    if(!customLoader){
                        $(mainElement).removeClass("hide");
                        $(".loader-screen").addClass("hide");
                    }

                    $(document).trigger(eventPrefix+'-templatesLoaded',[statuses]);
                }
            }
        });

    }

    /**
     * Returns a HTML element from a template with the template data appended to the new element.
     * @param {string} name        - The template name, without the 'template-' prefix
     * @param {obj} substData data
     * @return {JQuery} The HTML template object.
     */
    function getElement(name, substData) {
        var template = getTemplate(name, substData);
        var $element = $(template.html);
        var data = $element.data();
        $.extend(data, template.data);
        $element.data(data);
        return $element;
    }

    /**
     * Returns a HTML template.
     * @param {string} name The name of the template
     * @param {obj}
     * @return {object} The HTML template object. { {string} html, {object} data }
     */
    function getTemplate(name, substData) {
        var html = templates[name] ? templates[name].html : null;
        if(html == null) throw {message: '"' + name + '" template not loaded'};
        html = templates[name].html;
        if(substData) html = replaceTemplateData(name, substData);
        return {
            /** {string} The template HTML */
            html: html,
            /** {object} The substitution data */
            data: templates.data
        };
    }

    /**
     * Replaces ###PLACEHOLDER### items in a HTML string.
     * @param {string} name - the name of template
     * @param {object} [data] - Replacement data for ###PLACEHOLDER### items. The 'key' will be replaced with its 'value'. The key should not contain the hashes.
     * @return {string} The final HTML string.
     */
    function replaceTemplateData(name, data) {
        if(data == null) return templates[name].html;
        var encodeHTML = templates[name].htmlEncode;
        var html = templates[name].html;
        $.each(data,function(code, value) {
            code = regexpEscape('###' + code + '###');
            value = encodeHTML == "true" ? htmlEncode(value) : value;
            html = html.replace(new RegExp(code, 'g'), value);
        });
        return html;
    }

}